<template>
  <v-container fluid>
    <!--        <modal depressed icon="add" title="Добавить документ" name="Документ" component="add-document"></modal>-->
    <v-btn depressed color="primary" title="title" @click.prevent="addPatient" class="add-patient-custom-button">
      <v-icon left>add</v-icon>
      Пациента
    </v-btn>
    <v-data-table
      v-if="meta"
      item-key="uuid"
      class="elevation-1 patients-table"
      :headers="headers"
      :options.sync="options"
      :items="items"
      :page="filters.page"
      :items-per-page="10"
      :server-items-length="meta.total"
      :loading="loading"
      :footer-props="{
        'items-per-page-options': [10, 25, 50, 100, 200, 500, -1],
      }"
      @click:row="onRowClick"
    >
      <template v-slot:top>
        <v-container fluid>
          <!-- <v-text-field label="Email" single-line v-model="filters.email" @input="apiSearch()"></v-text-field> -->
          <!-- <v-col>
                  <v-text-field
                    label="Поиск"
                    append-icon="mdi-magnify"
                    single-line
                    v-model="filters.search"
                    @input="apiSearch()"
                  ></v-text-field>
                </v-col> -->
        </v-container>
      </template>
      <template v-slot:header.phone>
        <v-text-field
          label="Телефон"
          type="tel"
          maxlength="13"
          @click.stop="return false;"
          single-line
          v-model="filters.phone"
          @input="apiSearch()"
        ></v-text-field>
      </template>
      <template v-slot:header.fio>
        <v-text-field
          label="ФИО"
          @click.stop="return false;"
          single-line
          v-model="filters.fio"
          @input="apiSearch()"
        ></v-text-field>
      </template>
      <template v-slot:header.snils>
        <v-text-field
          label="СНИЛС"
          @click.stop="return false;"
          single-line
          v-model="filters.snils"
          @input="apiSearch()"
        ></v-text-field>
      </template>
      <template v-slot:header.sex>
        <v-select
          v-if="references.sexList.length"
          label="Пол"
          required
          item-text="name"
          item-value="id"
          v-model="filters.sex"
          :items="references.sexList"
          @change="apiSearch(true)"
          @click.stop="return false;"
        />
      </template>
      <template v-slot:header.age>
        <div>Возраст: {{ filters.age[0] }} - {{ filters.age[1] }}</div>
        <v-range-slider class="mb-0" max="99" min="0" v-model="filters.age" @change="apiSearch(true)"> </v-range-slider>
      </template>
      <template v-slot:header.organization.full_name>
        <v-autocomplete
          clearable
          label="Место работы"
          item-value="organization_id"
          item-text="organization_fullname"
          v-model="filters.organization_id"
          :loading="fetchOrg"
          :items="orgList"
          :menu-props="{ closeOnContentClick: true }"
          @change="apiSearch(true)"
          @click.stop="return false;"
        ></v-autocomplete>
      </template>
      <template v-slot:header.insurance_company.name>
        <v-text-field
          label="ДМС"
          @click.stop="return false;"
          single-line
          v-model="filters.dms"
          @input="apiSearch()"
        ></v-text-field>
      </template>
      <template v-slot:header.position>
        <v-text-field
          label="Должность"
          @click.stop="return false;"
          single-line
          v-model="filters.position"
          @input="apiSearch()"
        ></v-text-field>
      </template>

      <template v-slot:item.phone="{ item }">
        <div v-if="item.phone">{{ item.phone }}</div>
        <div v-if="item.phone2">{{ item.phone2 }}</div>
      </template>
      <template v-slot:item.birthday="{ item }">
        <div>{{ dayjs(item.birthday).format("DD.MM.YY") }}</div>
      </template>
      <template v-slot:item.action="{ item }">
        <v-btn v-if="canEditPatients" elevation="1" @click.stop="editPatient(item)" fab small class="mr-2" color="white">
          <v-icon>
            mdi-pencil
          </v-icon>
        </v-btn>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import dayjs from "dayjs";
import { parseProjectNameFromUrl } from "@/core/services/url.helpers";
import { PatientsRepository } from "@/modules/patients/patients.repository";
import { v4 as uuid } from "uuid";
import Vue from "vue";
import AddPatient from "./components/AddPatient.vue";
import { mapState } from "vuex";

export default Vue.extend({
  components: {},

  props: {},

  data() {
    return {
      dayjs,
      searchTimeout: undefined,
      orgList: [],
      fetchOrg: false,
      loading: false,
      //   Номер телефона, ФИО, Пол, Возраст, Дата Рождения, Компания, Отдел, Должность, Обслуживающая организация, Страховая
      headers: [
        {
          text: "Номер телефона",
          align: "start",
          value: "phone",
          width: "120px",
        },
        { text: "ФИО", value: "fio", width: "200px" },
        { text: "Пол", value: "sex", width: "100px" },
        { text: "Возраст", value: "age", sortable: false, width: "100px" },
        { text: "Дата рождения", value: "birthday", width: "100px" },
        { text: "Компания", value: "organization.full_name", width: "200px" },
        // { text: "Отдел", value: "structure" },
        { text: "Должность", value: "position", width: "200px" },
        { text: "Обслуживающая организация", value: "mis_organization.short_name", width: "200px" },
        { text: "Страховая", value: "insurance_company.name", width: "200px" },
        { text: "Снилс", value: "snils", width: "150px" },
        { text: "", value: "action", sortable: false, align: "right", width: "56px" },
        // { text: "Телефон", value: "phone" },
      ],
      items: [],
      meta: null,
      options: {},
      references: {
        sexList: [],
        healthGroups: [],
        workingConditions: [],
        scoreRange: { min: 0, max: 100 },
      },
      filters: {
        search: "",
        phone: "",
        fio: "",
        age: [0, 99],
        age_from: "",
        age_to: "",
        organization_id: null,
        email: "",
        dms: "",
        sex: null,
        page: 1,
        limit: 10,
        position: "",
      },
      snils: null,
    };
  },

  computed: {
    ...mapState("auth", ["profile"]),
    repo() {
      return new PatientsRepository();
    },

    projectName() {
      return parseProjectNameFromUrl(window.location.host);
    },

    canEditPatients() {
      return typeof this.profile.schedule_editor_flag === "undefined" || this.profile.can_edit_patients;
    },
  },
  watch: {
    options: {
      handler(val) {
        this.filters.page = val.page;
        this.filters.limit = val.itemsPerPage;
        this.filters.sort_by = val.sortBy[0];
        this.filters.sort_order = val.sortDesc[0] ? "DESC" : "ASC";
        this.loadList();
      },
      deep: true,
    },
  },
  async created() {
    this.references = await this.repo.getReferences();
    this.fetchOrg = true;
    const [orgs] = await Promise.all([this.$http.get(`/v1/organizations`, { params: { lang: "ru" } })]);
    if (orgs.data.success) {
      this.orgList.push({ organization_id: null, organization_fullname: "Все" });
      this.orgList.push(...orgs.data.data);
    }
    this.fetchOrg = false;

    await this.loadList();
  },
  methods: {
    async editPatient(patient) {
      console.log(`patient =>`, patient);
      const res = await this.$dialog.showAndWait(AddPatient, { width: "600px", patient, persistent: true });
      if (res) {
        this.loadList();
      }
    },
    async addPatient() {
      const res = await this.$dialog.showAndWait(AddPatient, { width: "600px", persistent: true });
      if (res) {
        this.loadList();
      }
    },
    apiSearch(immediately = false) {
      console.log(` =>`, this.filters);
      const formattedPhone = this.filters.phone.replace(/[^0-9]/g, "");

      this.$nextTick(() => {
        this.filters.phone = formattedPhone;
      });

      clearInterval(this.searchTimeout);
      this.searchTimeout = setTimeout(
        async () => {
          this.loading = true;
          if (this.filters.page !== 1) {
            this.filters.page = 1;
          }
          await this.loadList();
          this.loading = false;
        },
        immediately ? 0 : 1000,
      );
    },

    async loadList() {
      const { data: items, meta } = await this.repo.getAll(this.filters);
      if (items) {
        this.items = items.map(item => {
          let sex = "";

          if (item.sex === 1) {
            sex = "Женский";
          } else if (item.sex === 2) {
            sex = "Мужской";
          }
          //   const format = this.$date(item.birthday);
          //   item.birthday = format.format("DD.MM.YYYY");

          return {
            ...item,
            uuid: uuid(),
            sex: sex,
            fio: `${item.last_name} ${item.first_name} ${item.middle_name}`,
          };
        });
        console.log(this.items, "this.items");
      }
      this.meta = meta;
    },

    async searchBySnils() {
      if (this.snils.length) {
        try {
          const response = await this.$http.get(`v1/customers/find-by?snils=${this.snils}`);
          if (response.data.data) {
            this.items = [response.data.data].map(item => {
              let sex = "";

              if (item.sex === 1) {
                sex = "Женский";
              } else if (item.sex === 2) {
                sex = "Мужской";
              }

              return {
                ...item,
                uuid: uuid(),
                sex: sex,
                fio: `${item.last_name} ${item.first_name} ${item.middle_name}`,
              };
            });
            console.log(this.items, "this.items");
            // this.meta = null;
          }
        } catch (e) {
          console.error(e);
        }
      } else {
        await this.loadList();
      }
    },

    onRowClick(row) {
      console.log(`this.$store.state.auth =>`, this.$store.state.auth);
      const newPath = `/ikp?customer_id=${row.id}&doctor_id=${this.$store.state.auth.id}`;
      const domain = window.location.origin;
      window.open(domain + newPath, "_blank").focus();
    },
  },
});
</script>

<style lang="scss">
.patients-table {
  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type="number"] {
    -moz-appearance: textfield;
  }
  table {
    table-layout: fixed;
  }
  .v-data-table-header th,
  > .v-data-table__wrapper > table > thead > tr > th {
    padding: 0 8px;
    position: relative;
    .v-data-table-header__icon {
      position: absolute;
      background: #fff;
      right: 0;
      top: 50%;
      margin-top: -8px;
    }
    .v-text-field {
      padding-top: 0;
      margin-top: 0;
    }
    .v-input__slot {
      margin-bottom: 0;
    }
  }
  @media screen and (max-width: 1280px) {
    html & .v-data-table__wrapper > table > tbody > tr > td {
      font-size: 12px;
    }
    .v-data-table-header th {
      vertical-align: bottom;
      white-space: normal;
      position: relative;
      .v-data-table-header__icon {
        position: absolute;
        bottom: 0;
        right: 0;
        background: #fff;
      }
    }
  }
  @media screen and (max-width: 599px) {
    colgroup {
      display: none;
    }
    > .v-data-table__wrapper .v-data-table__mobile-row {
      min-height: 28px;
    }
    > .v-data-table__wrapper .v-data-table__mobile-table-row {
      padding-top: 16px;
    }
    &.theme--light > .v-data-table__wrapper > table > tbody > tr:not(:last-child) > td:last-child,
    &.theme--light > .v-data-table__wrapper > table > tbody > tr:not(:last-child) > th:last-child {
      padding-bottom: 16px !important;
    }
  }
}
.add-patient-custom-button {
  position: absolute;
  top: -58px;
  left: 180px;
  z-index: 200;
}
.v-input--range-slider {
  .v-messages {
    min-height: 0;
  }
}
</style>
